/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Err_Subscribe_FailedInputs */

const es_footer_err_subscribe_failed = /** @type {(inputs: Footer_Err_Subscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hemos podido completar la suscripción. Inténtalo de nuevo en unos minutos.`)
};

const gl_footer_err_subscribe_failed = /** @type {(inputs: Footer_Err_Subscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non puidemos completar a subscrición. Téntao de novo nuns minutos.`)
};

const en_footer_err_subscribe_failed = /** @type {(inputs: Footer_Err_Subscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not complete your subscription. Try again in a few minutes.`)
};

/**
* | output |
* | --- |
* | "We could not complete your subscription. Try again in a few minutes." |
*
* @param {Footer_Err_Subscribe_FailedInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_err_subscribe_failed = /** @type {((inputs?: Footer_Err_Subscribe_FailedInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Err_Subscribe_FailedInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_err_subscribe_failed(inputs)
	if (locale === "en") return en_footer_err_subscribe_failed(inputs)
	return es_footer_err_subscribe_failed(inputs)
});